import * as React from "react";
import type { SVGProps } from "react";
const SvgSlickArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.5}
      fillRule="evenodd"
      d="M1.057 8.943a1.333 1.333 0 0 1 0-1.886l6-6a1.333 1.333 0 1 1 1.885 1.886L3.885 8l5.057 5.057a1.333 1.333 0 1 1-1.885 1.886z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSlickArrow;
